export default __webpack_public_path__ + "static/media/Zoonostic_white.97a46bbd.svg";